<!-- =========================================================================================
    File Name: EmailSidebar.vue
    Description: Email Application Sidebar(Filter) (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="email__email-sidebar h-full">
    <!--    <div class="m-6 clearfix">-->
    <!--      <vs-button class="bg-primary-gradient w-full" icon-pack="feather" icon="icon-edit" @click="activePrompt = true">Compose</vs-button>-->
    <!--    </div>-->

    <!--    &lt;!&ndash; compose email &ndash;&gt;-->
    <!--    <vs-prompt-->
    <!--      class="email-compose"-->
    <!--      title="New Message"-->
    <!--      accept-text= "Send"-->
    <!--      @cancel="clearFields"-->
    <!--      @accept="sendMail"-->
    <!--      @close="clearFields"-->
    <!--      :is-valid="validateForm"-->
    <!--      :active.sync="activePrompt">-->
    <!--      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">-->
    <!--        <form @submit.prevent>-->
    <!--          <vs-input v-validate="'required|email'" name="mailTo" label-placeholder="To" v-model="mailTo" class="w-full mb-6" :danger="!validateForm && mailTo != ''" val-icon-danger="clear" :success="validateForm" val-icon-success="done" :color="validateForm ? 'success' : 'danger'" />-->
    <!--          <vs-input name="mailSubject" label-placeholder="Subject" v-model="mailSubject" class="w-full mb-6" />-->
    <!--          <vs-input name="mailCC" label-placeholder="CC" v-model="mailCC" class="w-full mb-6" />-->
    <!--          <vs-input name="mailBCC" label-placeholder="BCC" v-model="mailBCC" class="w-full mb-6" />-->
    <!--          <quill-editor v-model="mailMessage" :options="editorOption" />-->
    <!--          <vs-upload multiple text="Attachments" :show-upload-button="false" class="compose-mail-attachment" />-->
    <!--        </form>-->
    <!--      </component>-->
    <!--    </vs-prompt>-->

    <component
      :is="scrollbarTag"
      class="notification-list-filter-scroll-area"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="email__labels px-6 py-4">
        <h5 class="mb-8">カテゴリ</h5>
        <div class="email__lables-list">
          <div
            tag="span"
            class="email__label flex items-center mb-4"
            v-for="(category, index) in categories"
            :key="index"
          >
            <div
              class="ml-1 h-3 w-3 rounded-full mr-4"
              :class="'bg-' + category.color"
            ></div>
            <span
              class="text-lg"
              :class="{ 'text-primary': mailFilter == category.value }"
              >{{ category.text }}</span
            >
          </div>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    emailTags: {
      type: Array,
      required: false
    },
    mailFilter: {
      type: String,
      required: false
    },
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activePrompt: false,
      mailTo: "",
      mailSubject: "",
      mailCC: "",
      mailBCC: "",
      mailMessage: "",
      editorOption: {
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "blockquote",
              "code-block"
            ],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }]
          ]
        },
        placeholder: "Message"
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3
      }
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.mailTo != "";
    },
    baseUrl() {
      const path = this.$route.path;
      return path.slice(0, path.lastIndexOf("/"));
    },
    emailMeta() {
      return this.$store.state.email.meta;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    clearFields() {
      this.$nextTick(() => {
        this.mailTo = "";
        this.mailSubject = "";
        this.mailCC = "";
        this.mailBCC = "";
        this.mailMessage = "";
      });
    },
    sendMail() {
      this.clearFields();
    }
  },
  components: {
    quillEditor,
    VuePerfectScrollbar
  }
};
</script>
